export default "<a href=\"mailto:{{ cellValue }}\">{{ cellValue }}</a>\r\n";